var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      attrs: { id: "type-modal", active: _vm.displayModal },
      on: { close: _vm.close },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("vacation-modal", {
        ref: "vacationModal",
        attrs: { "can-edit": false },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingData,
              expression: "!isLoadingData",
            },
          ],
          staticClass: "modal-frame",
        },
        [
          _c(
            "div",
            { staticClass: "modal-wrapper" },
            [
              _c(
                "shadow-scroll-container",
                {
                  ref: "track",
                  staticClass: "modal-track",
                  attrs: { "with-top-scroller": true },
                },
                [
                  _c(
                    "div",
                    { staticClass: "modal-frame__header" },
                    [
                      _c("h2", { staticClass: "modal-frame__title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.isEditableMode
                              ? "Редактирование условия"
                              : "Новое условие"
                          )
                        ),
                      ]),
                      _vm.isEditableMode
                        ? _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.blur.top",
                                value: "Удалить",
                                expression: "'Удалить'",
                                modifiers: {
                                  hover: true,
                                  blur: true,
                                  top: true,
                                },
                              },
                            ],
                            attrs: {
                              size: "small",
                              label: "Удалить",
                              icon: { icon: "trash", color: "secondary" },
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("delete-item", _vm.recordData)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row period" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-md-6 col-xl-6" },
                      [
                        _c("c-select-2", {
                          staticClass: "period__select",
                          attrs: {
                            type: "select",
                            "floating-label":
                              "Период автоматического создания ведомости",
                            clearable: true,
                            searchable: true,
                            items: _vm.periods,
                            required: _vm.isSubmitted && _vm.periodError,
                            "required-message":
                              _vm.isSubmitted && _vm.periodError,
                            "required-mark": true,
                          },
                          model: {
                            value: _vm.form.period,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "period", $$v)
                            },
                            expression: "form.period",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col col-12 col-md-6 col-xl-6" }, [
                      _vm.form.period && Number(_vm.form.period.value) === 6
                        ? _c(
                            "div",
                            { staticClass: "period__days" },
                            [
                              _c("c-input-2", {
                                staticClass: "period__days-select",
                                attrs: {
                                  type: "integer-number",
                                  split: true,
                                  "max-length": 3,
                                  clearable: true,
                                  required:
                                    _vm.isSubmitted && _vm.customDaysError,
                                  "required-message":
                                    _vm.isSubmitted && _vm.customDaysError,
                                  "required-condition":
                                    _vm.isSubmitted && _vm.customDaysError,
                                  "required-mark": true,
                                  placeholder: "0",
                                },
                                model: {
                                  value: _vm.form.customDays,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customDays", $$v)
                                  },
                                  expression: "form.customDays",
                                },
                              }),
                              _vm._v(" дней "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm.form.period
                      ? _c(
                          "div",
                          { staticClass: "col col-12 col-md-12 col-xl-12" },
                          [
                            _c("span", { staticClass: "description" }, [
                              _vm._v(_vm._s(_vm.form.period.description)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-md-6 col-xl-6" },
                      [
                        _c("c-input", {
                          attrs: {
                            type: "select",
                            label: "Филиал",
                            clearable: true,
                            searchable: true,
                            multiple: true,
                            items: this.filials.allFilials,
                            placeholder: "Все",
                          },
                          model: {
                            value: _vm.form.filials,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "filials", $$v)
                            },
                            expression: "form.filials",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "modal-frame__actions" },
                    [
                      _c("c-button", {
                        staticClass: "modal-frame__action",
                        attrs: { label: "Отменить", size: "large" },
                        on: { click: _vm.close },
                      }),
                      _c("c-button", {
                        staticClass: "modal-frame__action",
                        attrs: {
                          label: "Сохранить",
                          size: "large",
                          color: "primary",
                          disabled: _vm.submitIsDisabled,
                        },
                        on: { click: _vm.submit },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "modal-actions" },
            [
              _c("c-button", {
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: { label: "Сохранить", color: "primary", size: "large" },
                on: { click: _vm.submit },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.isLoadingData
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.isLoadingData,
              height: "400",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }